/* istanbul ignore file */
import { DropDownFilterLayout, DateRangeFilterLayout, CheckboxGroupFilterLayout } from 'framework/list';
import React from 'react';
import { ApplicationSettings } from 'framework/uiTheme';
import type { HtmlFieldLayoutType } from 'framework/ui/field';
import {
  PhoneFieldLayout,
  SingleLineNameFieldLayout,
  LabeledFieldLayout,
  InternalLinkFieldLayout,
  IconFieldLayout,
  EmailFieldLayout,
  ExternalLinkFieldLayout,
  FormPageLayout,
  FLBaseInputLayout,
  FloatingLabelInputLayout,
  FLTextAreaLayout,
  NameInputLayout,
  FLNumberInputLayout,
  PhoneInputLayout,
  ButtonsSelectInputLayout,
  WysiwygInputLayout,
  MultiSelectInputLayout,
  LoadMultiSelectInputLayout,
  ButtonDropdownLayout,
  AutosuggestionDropdownLayout,
  InputListLayout,
  RadioButtonGroupLayout,
  CheckboxLayout,
  CheckboxGroupLayout,
  TogglerInputLayout,
  SwitchLayout,
  SectionRow,
  FLDropdownLayout as FloatingLabelDropdownLayout,
  FloatingLabelDateInputLayout,
  FormRow,
} from 'framework/ui/layout';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import useCustomHtmlTagHelper from './textTransformer/customHtmlTagsHelper';
import { useDocumentUiConfiguration } from 'infrastructure/documentUiConfiguration';
import {
  Alert,
  Tooltip,
  Button,
  Fade,
  Loading,
  SmallLoader,
  InputLoader,
  Badge,
  Collapse,
} from 'framework/ui/mui-builder';

type DavinciSettingsProps = {
  children: React.ReactNode;
  htmlFieldLayout: HtmlFieldLayoutType;
};

const DavinciSettings = ({ children, htmlFieldLayout: HtmlFieldLayout }: DavinciSettingsProps) => {
  const { getTimezone } = useAuthenticatedUserService();
  const { ArtifactsListLayout, ArtifactImageLayout, ArtifactDocumentLayout } = useDocumentUiConfiguration();

  const theme = {
    // pages
    FormPageLayout,
    // inputs
    BaseInputLayout: FLBaseInputLayout,
    InputLayout: FloatingLabelInputLayout,
    DropdownLayout: FloatingLabelDropdownLayout,
    TextAreaLayout: FLTextAreaLayout,
    AddressInputLayout: FormRow,
    NameInputLayout,
    NumberInputLayout: FLNumberInputLayout,
    PhoneInputLayout,
    ButtonsSelectInputLayout,
    WysiwygInputLayout,
    DateInputLayout: FloatingLabelDateInputLayout,
    MultiSelectInputLayout,
    LoadMultiSelectInputLayout,
    SelectInputLayout: FloatingLabelDropdownLayout,
    ButtonDropdownLayout,
    // fields
    BaseFieldLayout: LabeledFieldLayout,
    AddressFieldLayout: SectionRow,
    NameFieldLayout: SingleLineNameFieldLayout,
    ExternalLinkLayout: ExternalLinkFieldLayout,
    InternalLinkLayout: InternalLinkFieldLayout,
    AttachmentsListLayout: ArtifactsListLayout,
    PhoneFieldLayout,
    EmailFieldLayout,
    HtmlFieldLayout,
    AutosuggestionDropdownLayout,
    InputListLayout,
    RadioButtonGroupLayout,
    CheckboxLayout,
    CheckboxGroupLayout,
    TogglerInputLayout,
    SwitchLayout,
    IconFieldLayout,

    DropDownFilterLayout,
    DateRangeFilterLayout,
    CheckboxGroupFilterLayout,

    ArtifactImageLayout,
    ArtifactDocumentLayout,

    Alert,
    Tooltip,
    Button,
    Fade,
    Loading,
    SmallLoader,
    InputLoader,
    Badge,
    Collapse,
  };

  return (
    <ApplicationSettings theme={theme} getTimezone={getTimezone} useDefaultTextTransformer={useCustomHtmlTagHelper}>
      {children}
    </ApplicationSettings>
  );
};

export default DavinciSettings;
